
export const getProjectName = (context, createdBy, parameters, result) => {
  const { projectsMap } = context

  const { projectId, name } = result
  const { id } = parameters

  const project = projectsMap[id] || projectsMap[projectId]

  return project?.name || name || 'Undefined'
}
